import {Trans} from "react-i18next";

export default function TransCustom({nameSpace, prefix, children}) {
    return (
        <Trans ns={nameSpace} i18nKey={prefix}>{children}</Trans>
    )
}
